export default __webpack_public_path__ + "static/media/jayne.224a9a72.png";